import { createElement, useState, useEffect, Children, isValidElement, cloneElement, useRef } from "react";
import classNames from "classnames";
import ColorfulPopup from '../colorful-popup';
import MenuItem, { WrapItem } from './colorful-item';
import useOutsideClick from "./useOutsideClick";
import './index.scss';
const classPrefix = `au-dropdown`;
const ColorfulDropdown = ({ defaultActiveKey = '', position = 'bottom', popItems = [], arrow = createElement("i", { className: "triangle" }), children, onChange, ...otherProps }) => {
    const [value, setValue] = useState(defaultActiveKey);
    let childrenToRender = children || [];
    const items = [];
    const navRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        setValue(defaultActiveKey);
    }, [defaultActiveKey]);
    const changeActive = (key) => {
        if (value && value === key) {
            setValue(null);
        }
        else {
            setValue(key);
        }
    };
    useOutsideClick([navRef, contentRef], () => {
        setValue(null);
    });
    if (popItems?.length) {
        childrenToRender = popItems.map((option, i) => {
            return (createElement(MenuItem, { ...option, key: `${i + Math.floor(Math.random() * 100)}`, activekey: option?.activekey || '', title: option?.title || '' }, option?.children || ''));
        });
    }
    ;
    const navs = Children.map(childrenToRender, (child) => {
        if (isValidElement(child)) {
            items.push(child);
            const childProps = {
                ...child.props,
                arrow: child.props.arrow === undefined ? arrow : child.props.arrow,
                active: value && child.props.activekey === value,
                onClick: (e) => {
                    e.nativeEvent.stopImmediatePropagation();
                    changeActive(child.props.activekey);
                },
            };
            return cloneElement(child, childProps);
        }
        else {
            return child;
        }
    });
    return (createElement("div", { className: classNames(classPrefix, {
            [`${classPrefix}-open`]: !!value,
        }), ...otherProps },
        !popItems.length && '请添加子菜单',
        createElement("div", { className: `${classPrefix}-nav`, ref: navRef }, navs),
        createElement(ColorfulPopup, { className: `${classPrefix}-popup`, maskClassName: `${classPrefix}-popup-mask`, bodyClassName: `${classPrefix}-popup-body`, visible: !!value, position: position, mask: true },
            createElement("div", { ref: contentRef }, items.map((item, i) => {
                const isActive = item.props.activekey === value;
                return (createElement(WrapItem, { key: `${i + Math.floor(Math.random() * 100)}`, title: item.props.title, active: isActive },
                    !item.props.children && `请添加第${i}个子菜单内容`,
                    item.props.children));
            })))));
};
ColorfulDropdown.Item = MenuItem;
ColorfulDropdown.displayName = 'ColorfulDropdown';
export default ColorfulDropdown;
